import { ShapeType } from '@/services/shape';
import { getImageObject, getLayerRecolorEnabled, getRefName } from '../utils';
import { dataSourceWholeItems } from '@/resources/data-source';

export function DataItemImageValuesLayerHandler(
  resAst: Ast,
  layerAst: Ast,
  layer: StoreLayerItem,
  colors: StoreThemeColorItem[]
) {
  layer.attrs.resources = {
    images: getImageObject(resAst, getRefName(layerAst.attrsMap.ref), colors)
  };

  // 按 param 中value所在的索引顺序调整图片的顺序
  if (layerAst.attrsMap.source == 'weatherCurrentWeather') {
    const sourceItem = dataSourceWholeItems.find(
      (item) => item.key == 'weatherCurrentWeather'
    );
    const weatherRange = sourceItem?.weatherValueRange?.whole;
    if (weatherRange?.length) {
      const images: string[] = [];
      const imageTemp: string[] = Object.entries(
        layer.attrs.resources?.images as object
      )[0][1];
      weatherRange.forEach((weatherItem, index) => {
        const weatherVals = [weatherItem.value, ...(weatherItem.values ?? [])];
        const imgIndex = layerAst.children.findIndex((paramItem) => {
          const parmaVal = Number(paramItem.attrsMap.value ?? -1);
          return weatherVals.includes(parmaVal);
        });
        const imgSrc = imageTemp[imgIndex];
        if (imgSrc) {
          images[index] = imgSrc;
        }
        if (images.length != index + 1) {
          images.push('');
        }
      });
      for (const key in layer.attrs.resources?.images) {
        layer.attrs.resources.images[key] = images;
      }
    }
  }

  layer.attrs.recolorEnable = getLayerRecolorEnabled(
    resAst,
    getRefName(layerAst.attrsMap.ref)
  );
  layer.attrs = { ...layerAst.attrsMap, ...layer.attrs };
  layer.attrs.fillType = '普通填充';
  layer.type = ShapeType.ImageArray;
}
